export default '4.4.0';



//////////////////
// WEBPACK FOOTER
// ./node_modules/amplitude-js/src/version.js
// module id = wt+G
// module chunks = 4